import { getCategories, getTaxCodes } from "@/actuals/services";
import AccountingBillLine from "./AccountingBillLine";
import { useEffect, useState } from "react";

const AccountingBillLines = ({ accountingBill }) => {
    const [categories, setCategories] = useState([]);
    const [taxCodes, setTaxCodes] = useState([]);

    const accountingBillLines = accountingBill.accounting_bill_lines || [];

    useEffect(() => {
        async function loadData() {
            setTaxCodes(await getTaxCodes());
            setCategories(await getCategories());
        }
        loadData();
    }, []);

    return (
        <>
            {accountingBillLines.map((l) => {
                return (
                    <AccountingBillLine
                        key={l.id}
                        billLineData={l}
                        bill={accountingBill}
                        taxCodes={
                            taxCodes[accountingBill.legal_entity_id] || []
                        }
                        categories={
                            categories[accountingBill.legal_entity_id] || []
                        }
                    />
                );
            })}
        </>
    );
};

export default AccountingBillLines;
